var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('Data2_1')],1),_c('v-row',[_c('Data2_2')],1),_c('v-row',[_c('Data2_3')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }